import React from 'react';
import Charisma from './images/Charisma.png'; // Update the path to your image

const ImageOverlay = () => {
  return (
    <div
    style={{
      display: 'flex',
      justifyContent: 'flex-end', // Aligns image to the right
      alignItems: 'flex-end', // Aligns image to the bottom
      position: 'fixed',
      bottom: '30px',
      right: '30px',
      opacity: 0.5,
      zIndex: 1,
      pointerEvents: 'none',
    }}
  >
      <img
        src={Charisma}
        alt="Charisma"
        style={{
          maxWidth: '110px', // Adjust the size as needed
          maxHeight: '110px',
        }}
      />
    </div>
  );
};

export default ImageOverlay;